module.exports = __webpack_public_path__ + "img/HZ-A0155.e054a421.jpg";